import { common } from "@/services/common.request";
import { useMutation } from "react-query";

const usePlanDetails = () => {
  const {
    data,
    mutate: mutatePlanDetails,
    isLoading: isLoading,
  } = useMutation((uuid: string) => common.getPlanDetails(uuid));

  return {
    data,
    mutatePlanDetails,
    isLoading,
  };
};

export default usePlanDetails;
